@if (linkItem()) {
  @if (isAppUrl()) {
    <a
      [routerLink]="linkItem().url"
      [target]="target()"
      class="flex justify-between h-14 items-center"
    >
      <div class="text-mobileMd tablet:text-tabletMd text-black pr-3 desktop:text-desktopMd">
        {{ linkItem().title }}
      </div>
      <div
        class="rounded-full bg-primaryRed h-8 w-8 flex justify-center items-center text-white hover:bg-[#B90000] transition duration-300 shrink-0"
      >
        <sc-svg name="arrow-right" size="w-5 h-5"></sc-svg>
      </div>
    </a>
  } @else {
    <a [href]="linkItem().url" [target]="target()" class="flex justify-between h-14 items-center">
      <div class="text-mobileMd tablet:text-tabletMd text-black pr-3 desktop:text-desktopMd">
        {{ linkItem().title }}
      </div>
      <div
        class="rounded-full bg-primaryRed h-8 w-8 flex justify-center items-center text-white hover:bg-[#B90000] transition duration-300 shrink-0"
      >
        <sc-svg name="arrow-right" size="w-5 h-5"></sc-svg>
      </div>
    </a>
  }
}
